import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import ContinuingEducationRequest from "models/continuing-education";
import ContinuingEducationEnvironment from "models/continuing-education-environment";
import ContinuingEducationType from "models/continuing-education-type";
import ContinuingEducationTopic from "models/continuing-education-topic";

export interface ContinuingEducationSliceState {
    requests: ContinuingEducationRequest[],
    requestCount: number,
    environments: ContinuingEducationEnvironment[],
    types: ContinuingEducationType[],
    topics: ContinuingEducationTopic[]
}

export const initialState: ContinuingEducationSliceState = {
    requests: [],
    requestCount: 0,
    environments: [],
    types: [],
    topics: []
};

const ContinuingEducationSlice = createSlice({
    name: "continuing-education-slice",
    initialState,
    reducers: {
        setContinuingEducationRequests(state, { payload }: PayloadAction<ContinuingEducationRequest[]>) {
            state.requests = payload
        },
        setContinuingEducationRequestCount(state, { payload }: PayloadAction<number>) {
            state.requestCount = payload
        },
        addContinuingEducationRequest(state, { payload }: PayloadAction<ContinuingEducationRequest>) {
            state.requests = [payload, ...state.requests];
        },
        removeContinuingEducationRequest(state, { payload }: PayloadAction<string>) {
            state.requests = state.requests.filter(r => r.id !== payload);
            state.requestCount = Math.max(0, state.requestCount - 1);
        },
        setContinuingEducationFormFields(state, { payload }: PayloadAction<{
            environments: ContinuingEducationEnvironment[];
            types: ContinuingEducationType[];
            topics: ContinuingEducationTopic[];
        }>) {
            state.environments = payload.environments;
            state.types = payload.types;
            state.topics = payload.topics;
        }
    },
});

export const {
    setContinuingEducationRequests,
    setContinuingEducationRequestCount,
    addContinuingEducationRequest,
    removeContinuingEducationRequest,
    setContinuingEducationFormFields
} =ContinuingEducationSlice.actions

export default ContinuingEducationSlice.reducer;
